var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import OTPValidation from "./OTPValidation";
import LoginCommonInputButton from "../common/LoginCommonInputButton";
import di from "../di/index";
import { ECurrentLoginComponent, EResetPasswordFlow, } from "@domains/salesFeatures/Login/entities/iLogin";
import BackToLogin from "../common/BackToLogin";
var ForgotPassword = function (props) {
    var _a = props.showBackToLogin, showBackToLogin = _a === void 0 ? true : _a;
    var _b = __read(React.useState(false), 2), isShowOTPValidation = _b[0], setIsShowOTPValidation = _b[1];
    var _c = __read(useState(), 2), maskedUserData = _c[0], setMaskedUserData = _c[1];
    var _d = __read(React.useState(false), 2), showLoader = _d[0], setShowLoader = _d[1];
    var _e = __read(React.useState({
        isShowError: false,
        errorMessage: "",
        isShowErrorInHeader: false,
    }), 2), error = _e[0], setError = _e[1];
    var _f = __read(React.useState(), 2), resendOTPDuration = _f[0], setResendOTPDuration = _f[1];
    var handleSendOTP = function () {
        setShowLoader(true);
        setError({ isShowError: false, errorMessage: "" });
        var payload = {
            userName: props.partnerCode,
            loginFor: "partner",
        };
        di.login
            .forgotPassword(payload)
            .then(function (res) {
            if (res.data) {
                setMaskedUserData(res.data);
                setIsShowOTPValidation(true);
            }
            setShowLoader(false);
        })
            .catch(function (err) {
            generateError(err);
            setIsShowOTPValidation(false);
            setShowLoader(false);
        });
    };
    var verifyOTP = function (OTP) {
        setShowLoader(true);
        var payload = {
            userName: props.partnerCode,
            loginFor: "partner",
            validateotprequestDTO: {
                otpId: maskedUserData === null || maskedUserData === void 0 ? void 0 : maskedUserData.otpId,
                otp: OTP,
            },
        };
        di.login
            .validateForgotPassword(payload)
            .then(function (resp) {
            if (resp) {
                di.login.changeCurrentLoginComponent({
                    currentComponent: ECurrentLoginComponent.RESET_PASSWORD,
                    extraConfig: {
                        resetPasswordFlow: EResetPasswordFlow.FORGOT_RESET_PASSWORD,
                        OTPDetails: {
                            otp: OTP,
                            otpId: maskedUserData.otpId,
                        },
                    },
                });
            }
            setShowLoader(false);
        })
            .catch(function (err) {
            generateError(err);
            setShowLoader(false);
        });
    };
    var generateError = function (err) {
        if (typeof err.getErrorData() === "object" &&
            err.getErrorData().IsOtpBlocked) {
            setError({
                isShowError: true,
                errorMessage: err.getMessage(),
                isShowErrorInHeader: true,
            });
            setResendOTPDuration({
                minutes: err.getErrorData().MaxRequestTime,
                seconds: 0,
            });
        }
        else {
            setError({
                isShowError: true,
                errorMessage: (React.createElement("div", { className: "login-error-message tab-header gap-2 d-flex align-items-center p-10" },
                    React.createElement("i", { className: "edel-icon-validation" }),
                    err.getMessage())),
                isShowErrorInHeader: false,
            });
        }
    };
    return (React.createElement("div", { className: "d-flex flex-column justify-content-start align-items-center w-100 forget-password-container" },
        React.createElement("div", { className: "txt-midnight-blue DMSan_24_700 mb-2" }, "Forgot Password"),
        error.isShowError && error.isShowErrorInHeader && (React.createElement("div", { className: "login-error-message d-flex gap-3 tab-header p-15 mgtb-15" },
            React.createElement("i", { className: "edel-icon-forgot-login" }),
            React.createElement("div", { className: "line-140" }, error.errorMessage))),
        isShowOTPValidation ? (React.createElement(OTPValidation, { userData: maskedUserData, resendOTPCallback: handleSendOTP, verifyOTPCallback: verifyOTP, error: {
                isShowError: error.isShowError,
                errorMessage: !error.isShowErrorInHeader ? error.errorMessage : "",
            }, isShowLoader: showLoader, timerDuration: resendOTPDuration })) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "DMSanN_14_400 mb-5" }, "Enter your Partner Code below to continue"),
            React.createElement(LoginCommonInputButton, { name: "partnerCode", buttonOnClick: handleSendOTP, setInputValueCallback: function (value) {
                    if (value.length === 0) {
                        setError({ isShowError: false, errorMessage: "" });
                    }
                    props.setPartnerCode(value);
                }, buttonText: "Send OTP to Authenticate", inputValue: props.partnerCode, required: true, inputPlaceholder: "Enter Your Partner Code", buttonDisable: !!!props.partnerCode || showLoader, isShowInputLoader: showLoader, errorConfig: {
                    isShowError: error.isShowError,
                    errorMessage: !error.isShowErrorInHeader
                        ? error.errorMessage
                        : "",
                }, enableClickOnEnter: true }))),
        showBackToLogin && React.createElement(BackToLogin, null)));
};
export default ForgotPassword;
